import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pay_btn_forward_normal",
  "use": "icon-pay_btn_forward_normal-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pay_btn_forward_normal\"><path d=\"m4 10.6c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l3.7-3.8-3.7-3.6c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.8 3.8c.2.1.3.3.3.5s-.1.4-.2.6l-3.8 3.8c-.1.1-.3.2-.4.2z\" fill=\"#ccc\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pay_btn_forward_normal.svg
// module id = SK9P
// module chunks = 87